<template>
    <div class="comments-section">
        <div class="comment-title">Σχόλια</div>
        <div v-if="!editMode && (!this.comments || Object.keys(this.comments).length === 0)" class="no-comments">Δεν υπάρχουν σχόλια</div>
        <div v-else>
            <v-textarea
                v-if="editMode"
                v-model="newComment"
                filled
                label="Νέο σχόλιο"
                :clearable="clearable"
                :rules="editMode ? rules: []"
                class="field"
                auto-grow
            ></v-textarea>
            <div class="old-comments">
                <div v-for="[date, comment] of Object.entries(this.comments).reverse()" :key="date" class="comment">
                    <div class="comment-text-wrapper">
                        <div class="username">{{ comment.username }}:</div>
                        <div class="comment-text"> {{ comment.text }}</div>
                    </div>
                    <div class="timestamp">
                        {{ date }}
                        <v-icon color="orange">mdi-clock-outline</v-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            clearable: {
                type: Boolean
            },
            editMode: {
                type: Boolean
            },
            rules: {
                type: Array
            },
            comments: {
                type: Object,
                default: () => { return {} }
            }
        },
        watch: {
            newComment: {
                handler(newVal, oldVal) {
                    this.$emit('new-comment', newVal)
                }
            }
        },
        data() {
            return {
                newComment: null
            }
        },
        methods: {
            clear() {
                this.newComment = null
            }
        }
    }
</script>
<style scoped>
.comment-title {
    color: var(--cards-and-tables-text-color) !important;
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.no-comments {
    color: var(--cards-and-tables-text-color) !important;
    font-style: italic;
}

.comment {
    width: 98%;
    margin: 0 auto;
    margin-bottom: 0.4rem;
    background: #f0f0f0;
    padding: 0.7rem;
    border-radius: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-radius: 10px;
    box-shadow: 0px 4px 6px rgba(0,0,0,0.1);
}

.timestamp {
    font-size: 0.9rem;
    font-weight: 500;
}

.comments-section {
    border: solid 1px var(--cards-and-tables-text-color);
    padding: 1rem;
    border-radius: 5px;
    margin-bottom: 0.5rem;
    margin-top: 0.5rem;
    width: 100%;
    color: black;
}

.comment-text-wrapper {
    display: flex;
    flex-wrap: wrap;
}

.comment-text {
    font-style: italic;
}

.username {
    font-size: 1rem;
    margin-right: 0.2rem;
    font-weight: 500;
}
</style>
